export const clientsData = [
  {
    id: 1,
    name: 'Travel Counsellors',
    logo: 'https://storage.helloreaddy.io/project_files/74591a0a-789e-4a59-949a-af227a1ed8cb/793b54ee-f10e-4984-bcba-fe17ba97e498_compressed_WhatsApp-Image-2026-08-03-at-10.07.14-AM-1.webp',
  },
  {
    id: 2,
    name: 'Shimizu Corporation',
    logo: 'https://storage.helloreaddy.io/project_files/74591a0a-789e-4a59-949a-af227a1ed8cb/92f55e20-3a47-44a4-ae56-8bb4b9c3afc0_compressed_WhatsApp-Image-2026-08-03-at-10.07.14-AM.webp',
  },
  {
    id: 3,
    name: 'Fortune Group',
    logo: 'https://storage.helloreaddy.io/project_files/74591a0a-789e-4a59-949a-af227a1ed8cb/ba5f178e-31c7-451c-a5df-13de01060697_compressed_WhatsApp-Image-2026-08-03-at-10.07.15-AM-1.webp',
  },
  {
    id: 4,
    name: 'Client Logo',
    logo: 'https://storage.helloreaddy.io/project_files/74591a0a-789e-4a59-949a-af227a1ed8cb/b19996a6-e95b-4784-800d-67dd44608a1e_compressed_WhatsApp-Image-2026-08-03-at-10.07.15-AM-2.webp',
  },
  {
    id: 5,
    name: 'AstraZeneca',
    logo: 'https://storage.helloreaddy.io/project_files/74591a0a-789e-4a59-949a-af227a1ed8cb/ed6cf67d-fcd8-43a5-9dae-a3f91440e58a_compressed_WhatsApp-Image-2026-08-03-at-10.07.15-AM.webp',
  },
  {
    id: 6,
    name: 'Richmond Fellowship Society Bangalore',
    logo: 'https://storage.helloreaddy.io/project_files/74591a0a-789e-4a59-949a-af227a1ed8cb/4e22cb8f-5f41-4758-88a5-4347d21684e8_compressed_WhatsApp-Image-2026-08-03-at-10.07.16-AM-1.webp',
  },
  {
    id: 7,
    name: 'The Icon Bengaluru',
    logo: 'https://storage.helloreaddy.io/project_files/74591a0a-789e-4a59-949a-af227a1ed8cb/a3ead35e-5ec4-4d7f-bbe6-fe84c3cb3ccc_compressed_WhatsApp-Image-2026-08-03-at-10.07.16-AM.webp',
  },
];